// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__6i8_9","right":"Footer_right__2CkS0","buttons":"Footer_buttons__3uu9D"};